import React, { Component } from 'react'
import './calendarrowgroup.scss'

class CalendarRowGroup extends Component {
  render () {
    return (
      <div className='calendar-row-group'>
        <div className='calendar-row-group__heading'>
          <div className='calendar-row-group__info'>
            {this.props.renderInfo && this.props.renderInfo()}
          </div>
          <div className='calendar-row-group__controls'>
            {this.props.renderControls && this.props.renderControls()}
          </div>
        </div>
        {this.props.open && <div className='calendar-row-group__content'>{this.props.children}</div>}
      </div>
    )
  }
}

CalendarRowGroup.defaultProps = {
  open: true
}

export default CalendarRowGroup



// WEBPACK FOOTER //
// ./src/app/shared/components/Calendar/calendarRowGroup/index.js